import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { post, Token } from '../../../Script/Session';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Headline from '../../../components/headline/Headline';
import { Link } from '@mui/joy';
import { Box, Button, Dropdown, IconButton, Input, Menu, MenuButton, MenuItem, Table, Tooltip, Typography } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';
function ListViewVerein() {
    const { a } = useParams();
    const [afirst, setafirst] = useState(a);
    const [data, setdata] = useState();
    const navigate = useNavigate();
    const [wit, setWit] = useState("90.5%");
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    useState(() => {
        let body = {};
        body.token = Token.get();
        body.action = a;
        let response = post(body, "/listviews");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        console.log(response);
        setdata(JSON.parse(response));
    }, []);
    useEffect(() => {
        if (a != afirst) {
            window.location.reload()
        }

    }
        , [a]);
    return (
        <>
            <div style={{
                width: wit,
                position: "fixed",
                flexDirection: "column",
                top: "0",
                right: "0",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                overflowY: "auto",
            }}>
                <Headline title={a == "konzept" ? "Konzepte" : "Empfehlungen"} />
                <Input
                    placeholder="Suche..."
                    startDecorator={<SearchIcon />}
                    value={searchTerm}
                
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setDebouncedSearchTerm(e.target.value);
                    }}
                    sx={{ width: 500, mt: 5 }}
                />
                <Table sx={{width: "99%", mt: 2}}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Gesellschaft</th>
                            <th>Sparte</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && Array.isArray(data.result) &&data.result.filter(item => item.name?.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td><Link href={window.location.origin +  "/tarif/"+ item.id + "/"+ item.subkathid}>{item.name}</Link></td>
                                    <td>{item.gesellschaft}</td>
                                    <td>{item.subkath}</td>
                                </tr>
                            )


                        })}



                    </tbody>
                </Table>



            </div>
            <NavigationBar state={"vergleiche"} back={true} />
        </>
    )
}

export default ListViewVerein
